// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"hP","logoWrapper":"hQ"};